export const INIT_LOCAL_STORAGE = 'Init Local Storage';
export const SET_LOCAL_STORAGE_ITEM = 'Set Local Storage Item';
export const REMOVE_LOCAL_STORAGE_ITEM = 'remove Local Storage Item';
